import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../data-services/index';
import { IUser, IContactExists, ILogin } from '@ebb-v2/ebb-integration';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { take, map } from 'rxjs/operators';

export interface IUserApp {
  userId: string;
  appId: string;
}

@Component({
    selector: 'ebb-portal-impersonate',
    templateUrl: './impersonate.component.html',
    standalone: false
})
export class ImpersonateComponent implements OnInit {

  constructor(
    private apiAuthentication: AuthenticationService,
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {

  }
}
